module.exports = __webpack_public_path__ + "img/hotels-home.2a36c44b.jpg";